<template>
  <TemplateModal ref="modal" center width="900" :scrollDisable="scrollDisable">
    <template v-slot:activator>
      <BaseButton
        @click="openModal()"
        default_icon="button-edit"
        :text="localStorage.translations.pages.common.buttons.sign"
      />
    </template>
    <div class="send">
      <v-responsive :aspect-ratio="width / height" ref="vResponsive" class="text-center">
        <canvas
          class="canvas"
          ref="myCanvas"
          id="myCanvas"
          :width="sizeResponsiveBlock.width >= width ? height : sizeResponsiveBlock.width"
          :height="sizeResponsiveBlock.height >= width ? height : sizeResponsiveBlock.height"
          style="
            background-color: #ffffff;
            border: 5px solid #277faf;
            border-radius: 40px;
            cursor: pointer;
          "
          @mousedown="onMouseDown"
          @mousemove="onMouseMove"
          @mouseup="onMouseUp"
          @mouseover="onMouseOver"
          v-touch="{
            move: onTouchMove,
            start: onTouchStart,
            end: onTouchEnd,
          }"
        >
          Canvas is not supported
        </canvas>
      </v-responsive>
      <BaseButton
        :class="{ hide: !signAdd }"
        class="clearBtn"
        :text="localStorage.translations.pages.common.buttons.clear"
        @click="clearList"
      />
      <div class="grid">
        <BaseInput
          v-model="first_name"
          :label="localStorage.translations.pages['setting-personal_area'].labels['imya']"
          :rules="['required']"
        />
        <BaseInput
          v-model="last_name"
          :label="localStorage.translations.pages['setting-personal_area'].labels['familiya']"
          :rules="['required']"
        />
      </div>
    </div>
    <template v-slot:submit>
      <div class="buttonGrid">
        <BaseButton
          :text="localStorage.translations.pages.common.buttons.sohranit"
          @click="sendData"
          default_icon="button-save"
          :disabled="!signAdd"
        />
        <BaseButton
          :text="localStorage.translations.pages.common.buttons.otmenit"
          @click="$refs.modal.closeModal"
          default_icon="button-cross"
          background-color="#EB5757"
        />
      </div>
    </template>
  </TemplateModal>
</template>

<script>
import TemplateModal from 'components/templates/TemplateModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StatisticProjectReportsSignAddModal',
  props: {},
  components: {
    TemplateModal,
  },
  data: () => ({
    dialog: false,
    draw: false,
    mouse: { x: 0, y: 0 },
    context: null,
    first_name: null,
    last_name: null,
    signAdd: false,
    width: 800,
    height: 555,
    sizeResponsiveBlock: {
      width: 0,
      height: 0,
    },
    scrollDisable: false,
  }),
  watch: {
    '$refs.modal.dialog'() {
      if (this.$refs.modal && this.$refs.modal.dialog) {
        this.$forceUpdate()
        this.$nextTick(() => {
          var canvas = this.$refs.myCanvas
          if (canvas) {
            this.context = canvas.getContext('2d')
          }
          this.respSize()
          this.first_name = this.guest_periodReport__show.data['client_person_data'].first_name
          this.last_name = this.guest_periodReport__show.data['client_person_data'].last_name
        })
      } else {
        this.canvas = null
        this.first_name = null
        this.last_name = null
        this.signAdd = false
      }
    },
    windowWidth() {
      this.respSize()
    },
  },
  computed: {
    ...mapGetters('user', ['userData']),
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('guest_periodReport', ['guest_periodReport__show']),

    windowWidth() {
      return this.$vuetify.breakpoint.width
    },
    lineWidth() {
      const defaultLineWidth = 10
      const percentage =
        this.sizeResponsiveBlock.width >= this.width
          ? 1
          : ((this.width - this.sizeResponsiveBlock.width) / this.width) * 100
      return defaultLineWidth - (defaultLineWidth * percentage) / 100
    },
  },
  created() {},
  methods: {
    ...mapActions('workClient', ['onWorkClientSendOffer']),
    openModal() {
      this.$refs.modal.openModal()
      this.sender_email = this.userData.email
      this.subject = this.textTheme
    },
    onMouseDown(e) {
      this.mouse.x = e.offsetX
      this.mouse.y = e.offsetY
      this.draw = true
      this.context.beginPath()
      this.context.moveTo(this.mouse.x, this.mouse.y)
    },
    onMouseMove(e) {
      if (this.draw == true) {
        this.mouse.x = e.offsetX
        this.mouse.y = e.offsetY
        this.context.lineWidth = this.lineWidth
        this.context.lineTo(this.mouse.x, this.mouse.y)
        this.context.stroke()
        this.signAdd = true
      }
    },
    onMouseUp(e) {
      if (this.draw) {
        this.mouse.x = e.offsetX
        this.mouse.y = e.offsetY
        this.context.lineTo(this.mouse.x, this.mouse.y)
        this.context.stroke()
        this.context.closePath()
        this.draw = false
      }
    },

    onMouseOver() {
      this.context.closePath()
      this.draw = false
    },

    onTouchStart(e) {
      this.scrollDisable = true
      var x = window.scrollX
      var y = window.scrollY
      window.onscroll = function () {
        window.scrollTo(x, y)
      }
      // console.log('onTouchStart', e)
      e.preventDefault()
      this.mouse.x = e.touchstartX - 40
      this.mouse.y = e.touchstartY - 120
      this.draw = true
      this.context.beginPath()
      this.context.moveTo(this.mouse.x, this.mouse.y)
    },
    onTouchMove(e) {
      // console.log('onTouchMove', e)
      e.preventDefault()
      if (this.draw == true) {
        this.mouse.x = e.touchmoveX - 40
        this.mouse.y = e.touchmoveY - 120
        this.context.lineWidth = this.lineWidth
        this.context.lineTo(this.mouse.x, this.mouse.y)
        this.context.stroke()
        this.signAdd = true
      }
    },
    onTouchEnd(e) {
      // console.log('onTouchEnd', e)
      e.preventDefault()
      if (this.draw) {
        this.mouse.x = e.touchendX - 40
        this.mouse.y = e.touchendY - 120
        this.context.lineTo(this.mouse.x, this.mouse.y)
        this.context.stroke()
        this.context.closePath()
        this.draw = false
      }
      window.onscroll = function () {}
      this.scrollDisable = false
    },
    sendData() {
      if (this.$refs.modal.validate()) {
        const date = new Date()
        this.$emit('signData', {
          image: this.$refs.myCanvas
            .toDataURL('image/png')
            .replace('image/png', 'image/octet-stream'),
          first_name: this.first_name,
          last_name: this.last_name,
          date: date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear(),
        })
        this.$refs.modal.closeModal()
      }
    },
    clearList() {
      this.$refs.myCanvas.width += 0
      this.signAdd = false
    },
    respSize() {
      this.$nextTick(() => {
        console.log(this.$refs.vResponsive.$el)
        this.sizeResponsiveBlock.width =
          this.$refs.vResponsive && this.$refs.vResponsive.$el.offsetWidth - 10
        this.sizeResponsiveBlock.height =
          this.$refs.vResponsive && this.$refs.vResponsive.$el.offsetHeight - 10
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.send:deep() {
  width: 100%;
  display: grid;
  row-gap: 20px;
  .hide {
    opacity: 0;
    transition: 0.3s;
  }
  .clearBtn {
    justify-self: center;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
  }
  .canvas {
    -webkit-touch-callout: none;

    /* iOS Safari */
    -webkit-user-select: none;

    /* Safari */
    -khtml-user-select: none;

    /* Konqueror HTML */
    -moz-user-select: none;

    /* Firefox */
    -ms-user-select: none;

    /* Internet Explorer/Edge */
    user-select: none;
  }
}
.buttonGrid:deep() {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}
</style>
